/* eslint-disable import/prefer-default-export */
import { useQuery } from 'react-query';
import adressesActions from '../actions/adresses.actions';

export function useGetAdresses(params) {
    return useQuery(['adresses', { client: params.entite_id }], () => adressesActions.list(params));
}
